module.exports = __webpack_public_path__ + "img/img12.e5ad05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img12.png
// module id = 188
// module chunks = 0